import { useSelectedProjectSelector } from "../../../store/projects/selectors";
import { dispatch } from "../../../store";
import { changeSelectedTypeAction } from "../../../store/projects/actions";
import { Tabs, Tab } from "../../../components/Tabs";

const projectTabs: Tab[] = [
  { code: "current", name: "Current Projects" },
  { code: "recommendation", name: "Recommended Projects" },
  { code: "saved", name: "Saved Projects" },
];

export const ProjectTabs = () => {
  const selectedType = useSelectedProjectSelector();

  const handleTabChange = (code: string) => {
    dispatch(changeSelectedTypeAction(code as "recommendation" | "current" | "saved"));
  };

  return <Tabs tabs={projectTabs} selected={selectedType} onSelect={handleTabChange} />;
};
